<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <form [formGroup]="resetPasswordForm">
    <ion-label class="title">{{ 'PUBLIC.reset.title' | translate }}</ion-label>
    <ion-label>{{ 'PUBLIC.reset.instructions' | translate }}</ion-label>
    <ion-item class="item-input item-interactive" mode="md">
      <ion-input
        label="{{ 'PUBLIC.email.capitalised' | translate }}"
        labelPlacement="stacked"
        autocomplete="email"
        type="email"
        formControlName="login"
      ></ion-input>
    </ion-item>
    <div class="ion-input__errors">
      <span *ngIf="resetPasswordForm.controls.login.hasError('required') && resetPasswordForm.touched">
        {{ 'PUBLIC.email.empty' | translate }}
      </span>
    </div>
    <!-- Login -->
    <ion-button (click)="resetPassword()" mode="ios">{{ 'PUBLIC.reset.cta' | translate }}</ion-button>
  </form>
</ion-content>
